import { FieldErrors } from 'react-hook-form'

// 必須未回答のまま送信したときに、エラーになっている設問までスクロールして気づけるようにする
// react-hook-form の shouldFocusError は Controller に ref を渡していない設問では効かないため、DOM から探す
export function scrollToFirstErrorInForm(formId: string, errors: FieldErrors) {
  const form = document.getElementById(formId)
  if (!form) return

  const errorNames = Object.keys(errors)
  // errors の並びは設問の登録順で画面の並びとは限らないため、DOM 上で最初にあるものを選ぶ
  const label = Array.from(form.querySelectorAll<HTMLLabelElement>('label[for]'))
    .find(element => errorNames.includes(element.htmlFor))

  label?.scrollIntoView({ behavior: 'smooth', block: 'center' })
}
